import gsap from 'gsap';
import Flip from 'gsap/Flip';

gsap.registerPlugin(Flip);

document.addEventListener('DOMContentLoaded', (event) => {
    let mm = gsap.matchMedia();
    gsap.registerPlugin(Flip);
    function blogListHover(targetEl) {
        const listItems = targetEl.querySelectorAll('.work_item');
        const shape = targetEl.querySelector('.work_item-pad');
        const listsParent = targetEl.querySelector('.work_list');

        listItems[0].classList.add('is-first');
        listItems[listItems.length - 1].classList.add('is-last');

        listItems.forEach(function (li, i) {
            li.setAttribute('index', i);
            const image = li.querySelector('.work_image');
            li.addEventListener('mouseover', function (e) {
                const prevHoveredEl = e.relatedTarget.parentElement;
                //image
                function fromBottom() {
                    image.style.top = 'auto';
                    image.style.bottom = '0';
                }
                function fromTop() {
                    image.style.top = '0';
                    image.style.bottom = 'auto';
                }
                if (i < prevHoveredEl.getAttribute('index')) {
                    fromBottom();
                }

                if (i === 0) {
                    fromTop();
                }

                if (i === 0 && i < prevHoveredEl.getAttribute('index')) {
                    fromBottom();
                }

                if (
                    i === listItems.length - 1 &&
                    i > prevHoveredEl.getAttribute('index')
                ) {
                    fromTop();
                }
                if (
                    i === listItems.length - 1 &&
                    !prevHoveredEl.classList.contains('work_item')
                ) {
                    fromBottom();
                }
                if (
                    i > prevHoveredEl.getAttribute('index') &&
                    i !== listItems.length - 1
                ) {
                    fromTop();
                }

                image.classList.add('is-active');
                let shapeState = Flip.getState(shape, { props: 'height' });
                li.appendChild(shape);
                Flip.from(shapeState, {
                    duration: 0.4,
                    ease: 'power4.out',
                });
            });
            li.addEventListener('mouseleave', function (e) {
                let currentItem = e.target;
                let state = Flip.getState(shape, { props: 'height' });
                if (
                    currentItem.classList.contains('is-first') ||
                    currentItem.classList.contains('is-last')
                ) {
                    Flip.from(state, {
                        duration: 0.4,
                        ease: 'power4.out',
                    });
                }
                //image
                image.classList.remove('is-active');
            });
        });

        listsParent.addEventListener('mouseover', function (e) {
            shape.classList.add('is-active');

            let state = Flip.getState(shape, { props: 'height' });
            Flip.from(state, {
                duration: 0.3,
                ease: 'power2.out',
            });
        });
        listsParent.addEventListener('mouseleave', function () {
            shape.classList.remove('is-active');
            let state = Flip.getState(shape, { props: 'height' });
            Flip.from(state, {
                duration: 0.3,
                ease: 'power2.out',
            });
        });
    }
    const workComponent = document.querySelector('.work_component');
    mm.add('(hover:hover)', () => {
        blogListHover(workComponent);
    });
});
